export default {"src":"/_next/static/media/ForgetPassword.21b2ae71.svg","height":731,"width":790,"blurWidth":0,"blurHeight":0};